(() => {
  const base = window.Shopify?.routes?.root || '/';
  document.querySelectorAll('[data-product-root]').forEach(root => {
    root.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click',() => {
      const input = root.querySelector('[name="quantity"]');
      const max = input.max === '' ? Infinity : Number(input.max);
      input.value = Math.max(1,Math.min(max,(Number(input.value) || 1) + Number(button.dataset.quantityStep)));
      input.dispatchEvent(new Event('input',{bubbles:true}));
    }));
    const dialog = document.querySelector('[data-product-zoom-dialog]');
    root.querySelector('[data-product-zoom]')?.addEventListener('click',() => {
      const source = root.querySelector('[data-main-image]');
      dialog.querySelector('img').src = source.currentSrc || source.src;
      dialog.showModal();
    });
    dialog?.querySelector('[data-product-zoom-close]')?.addEventListener('click',() => dialog.close());
    dialog?.addEventListener('click',event => { if (event.target === dialog) dialog.close(); });
    const panel = root.querySelector('[data-pairing]');
    if (!panel) return;
    const product = JSON.parse(root.querySelector('[data-product-json]').textContent);
    const form = root.querySelector('form[action*="/cart/add"]');
    const button = panel.querySelector('[data-pair-add]');
    const original = button.textContent;
    const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:panel.dataset.currency}).format(amount / 100);
    const currentVariant = () => product.variants.find(v => String(v.id) === form.querySelector('[name="id"]').value);
    const rows = [...panel.querySelectorAll('[data-pair-row]')];
    let busy = false;
    function sync() {
      const variant = currentVariant();
      const quantity = Math.max(1,Number(form.querySelector('[name="quantity"]').value) || 1);
      let total = (variant?.price || 0) * quantity;
      panel.querySelector('[data-pair-main-price]').textContent = money(total);
      panel.querySelector('[data-pair-main-variant]').textContent = variant ? (variant.options.join(' / ') === 'Default Title' ? '' : variant.options.join(' / ')) + (quantity > 1 ? ' × ' + quantity : '') : panel.dataset.unavailable;
      rows.forEach(row => {
        const option = row.querySelector('select').selectedOptions[0];
        const price = Number(option?.dataset.price) || 0;
        row.querySelector('[data-pair-price]').textContent = money(price);
        row.classList.toggle('is-selected',row.querySelector('input').checked);
        if (row.querySelector('input').checked) total += price;
      });
      panel.querySelector('[data-pair-total]').textContent = money(total);
      button.disabled = busy || !variant?.available || Boolean(form.querySelector('[data-add]').disabled);
      button.title = !variant?.available ? panel.dataset.disabledMessage : '';
    }
    panel.addEventListener('change',sync);
    root.addEventListener('sp:variant-change',sync);
    form.querySelector('[name="quantity"]')?.addEventListener('input',() => queueMicrotask(sync));
    button.addEventListener('click',async () => {
      if (busy || !form.reportValidity()) return;
      const status = panel.querySelector('[data-pair-status]');
      const link = panel.querySelector('[data-pair-cart]');
      status.hidden = true; link.hidden = true;
      busy = true; button.disabled = true; button.textContent = panel.dataset.adding;
      try {
        const cart = await window.spStock.refresh();
        const variant = currentVariant();
        const quantity = Number(form.querySelector('[name="quantity"]').value);
        if (!variant?.available || !Number.isInteger(quantity) || quantity < 1) throw new Error(panel.dataset.disabledMessage);
        const properties = {};
        for (const [key,value] of new FormData(form)) { const match = /^properties\[(.+)\]$/.exec(key); if (match && typeof value === 'string' && value.trim()) properties[match[1]] = value; }
        const items = [{id:variant.id,quantity,properties}];
        const stock = new Map([[String(variant.id),variant.stock]]);
        rows.forEach(row => {
          if (!row.querySelector('input').checked) return;
          const option = row.querySelector('select').selectedOptions[0];
          items.push({id:Number(option.value),quantity:1});
          stock.set(option.value,option.dataset.stock === '' ? null : Number(option.dataset.stock));
        });
        for (const item of items) {
          const available = stock.get(String(item.id));
          const inCart = cart.items.filter(i => String(i.variant_id) === String(item.id)).reduce((sum,i) => sum + i.quantity,0);
          if (available !== null && available !== undefined && item.quantity + inCart > available) throw new Error(panel.dataset.stockError);
        }
        const response = await fetch(base + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || panel.dataset.error);
        status.textContent = panel.dataset.added;
        status.classList.remove('has-error'); status.hidden = false; link.hidden = false;
        await window.spStock.refresh();
      } catch (error) {
        status.textContent = error.message || panel.dataset.error;
        status.classList.add('has-error'); status.hidden = false;
        await window.spStock.refresh().catch(() => {});
      } finally { busy = false; button.textContent = original; sync(); }
    });
    sync();
  });
})();

